import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Automation } from 'api/automations';
import { RootState } from 'data';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  automation: Automation;
}

const StyledStatus = styled.span`
  color: var(--magenta-70);
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #f6f6f6;
  padding: var(--spacing-02) var(--spacing-03);
  border-radius: var(--spacing-02);
`;

const StyledField = styled.span`
  color: var(--blue-60);
`;

export const KeyEventListItem: React.FC<Props> = ({ automation }) => {
  const { byId } = useSelector((state: RootState) => state.fields);
  const field = byId[automation.actionsV2[0].input.fieldId];
  const trigger = automation.triggerV2;
  const translate = useTranslation('templates.tab.key_events.any_status');

  return (
    <FormattedMessage
      id="templates.tab.key_events.key_event_item"
      values={{
        fl: (chunks) => <StyledStatus>{chunks}</StyledStatus>,
        tl: (chunks) => <StyledStatus>{chunks}</StyledStatus>,
        fromLabel: trigger.input.fromFieldLabel ?? translate,
        toLabel: trigger.input.toFieldLabel,
        fieldLabel: field?.[1]?.fieldLabel,
        ref: trigger.template.includes('PHASE') ? 'phase' : 'task',
        field: (chunks) => <StyledField>{chunks}</StyledField>,
      }}
    />
  );
};
